import Select from 'react-select';
import styled from 'styled-components';

export const SelectWrapper = styled(Select)`
  border: ${({ theme }) => `1px solid ${theme.selectControlBorderColor}`};
  border-radius: 4px;
`;
